import React, { useEffect } from 'react'
import Header from '../../headerone/Main'
import Bredcom from '../../Bredcom/Main'
import HousingDetails from '../mendepartmentdetails/Housing'


function Housing() {

  useEffect(() => {
    document.getElementById("title").innerHTML="Housing and Community Development || State of GTS";
  }, [])


  return (
    <>
        {/* Header is now rendered at app level in routes/index.js to prevent remounting on navigation */}

        <div className="page-wrapper">
        <Bredcom 
            subtitle="home"
            title="Housing & Urban Development"
            subtitledown="Department of Housing & Community Development"
           />
            <HousingDetails/>
        </div>
    </>
  )
}

export default Housing